/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Paperclip: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.225 3.68491L8.625 1.08491C10.225 -0.515091 12.825 -0.315091 14.625 1.48491C16.325 3.38491 16.525 6.28491 15.025 7.98491L7.825 15.7849C7.625 15.9849 7.325 16.0849 7.025 15.7849C6.725 15.4849 6.825 15.0849 7.025 14.8849L14.225 7.18491C15.325 5.98491 15.025 3.78491 13.825 2.38491C12.525 1.08491 10.525 0.784909 9.425 1.98491L7.025 4.58491L2.425 9.68491L1.825 10.2849C1.025 11.1849 1.025 12.4849 1.925 13.4849C2.725 14.4849 4.125 14.5849 4.925 13.7849L7.825 10.6849C7.825 10.6849 7.525 10.4849 7.425 10.3849C6.725 9.68491 6.625 8.48491 7.225 7.88491L9.225 5.68491C9.825 4.98491 10.825 5.08491 11.525 5.78491C12.125 6.58491 12.225 7.68491 11.625 8.28491L11.025 8.88491L9.525 10.4849L5.625 14.6849C4.425 15.9849 2.425 15.8849 1.025 14.3849C-0.375 12.8849 -0.275 10.7849 0.925 9.48491L1.525 8.88491L6.225 3.68491ZM10.025 6.58491L8.025 8.78491C7.825 8.88491 7.925 9.28491 8.125 9.48491C8.325 9.68491 8.625 9.78491 8.825 9.58491L10.225 7.98491L10.825 7.38491C11.025 7.28491 10.925 6.88491 10.725 6.68491C10.525 6.48491 10.225 6.38491 10.025 6.58491Z'
			/>
		</Svg>
	);
};

export { Paperclip };
